import { PRODUCT_TYPE } from '@ahmdigital/constants';

type BuildFinancialProductCategoriesArgs = {
  hospitalTier?: string | null;
  isSoftBundle: boolean;
  productType: string;
};

const slugify = (value: string) => value.toLowerCase().replace(/\s+/g, '-');

const buildFinancialProductCategories = ({
  hospitalTier,
  isSoftBundle,
  productType,
}: BuildFinancialProductCategoriesArgs): string[] => {
  const categories = ['health-insurance'];

  const isHospitalProduct = productType === PRODUCT_TYPE.HOSPITAL;
  const isExtrasProduct = productType === PRODUCT_TYPE.EXTRAS;
  const isCombinedProduct =
    isSoftBundle || productType === PRODUCT_TYPE.PACKAGE || productType === PRODUCT_TYPE.COMBINED;

  if (isCombinedProduct) {
    categories.push('health-insurance/hospital-and-extras');
  }

  if (isHospitalProduct || isCombinedProduct) {
    categories.push('health-insurance/hospital-cover');

    if (hospitalTier) {
      categories.push(`health-insurance/hospital-cover/${slugify(hospitalTier)}`);
    }
  }

  if (isExtrasProduct || isCombinedProduct) {
    categories.push('health-insurance/extras');
  }

  return categories;
};

export default buildFinancialProductCategories;
